import type { AxiosInstance } from 'axios';

import type { TIndexType, TRawAlertRule, TRawAlertRulesRequestDto } from '../../types';

export type TBatchAlertRulesRequestDto = {
  create: TRawAlertRulesRequestDto[];
  update: TRawAlertRulesRequestDto[];
  delete: string[];
};

export type TBatchAlertRulesResponseDto = {
  created: TRawAlertRule[];
  updated: TRawAlertRule[];
  deletedCount: number;
};

export type TAlertRulesRequestParams = {
  wellboreId: number;
  indexType: TIndexType;
};

export class AlertRulesApi {
  baseUrl = '/alert-rules/api/v1/alert-rules';

  private readonly agent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  fetchAlertRules(params: TAlertRulesRequestParams, signal?: AbortSignal): Promise<TRawAlertRule[]> {
    return this.agent.get<TRawAlertRule[]>(this.baseUrl, { params, signal }).then((res) => res.data);
  }

  saveAlertRules(body: TBatchAlertRulesRequestDto, signal?: AbortSignal): Promise<TBatchAlertRulesResponseDto> {
    return this.agent
      .put<TBatchAlertRulesResponseDto>(this.baseUrl + '/batch', body, { signal })
      .then((res) => res.data);
  }
}
